import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logout } from '../api';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { authTokenService } from '@/bundle/shared/services/authTokenService';
import { sessionStorageService } from '@/helpers/storageHelpers';
import { useNavigate } from 'react-router';
import { CURRENT_ROLE_KEY } from '@/const/shared';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';
import { useUser } from '@/context/userContext';

export const useLogout = () => {
  const { clearUser } = useUser();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { clearHistory } = useStatefulNavigation();

  return useMutation({
    mutationKey: ['logout'],
    mutationFn: () => {
      return logout();
    },
    onSuccess(response) {
      if (response?.error) return;

      clearUser();
      amplitudeService.resetUser();
      authTokenService.removeTokens();

      queryClient.removeQueries();
      sessionStorageService.remove(CURRENT_ROLE_KEY);
      clearHistory();

      navigate(getLoginPath());
    },
  });
};
